import { useQuery } from "@tanstack/react-query";
import { getTransactionHifiair } from "../api";

export const useGetTransactionHifiair = (filter?: {
  startDate?: string;
  endDate?: string;
}) => {
  const cleanedFilter = Object.fromEntries(
    Object.entries(filter || {}).filter(
      ([_, value]) => value !== undefined && value !== null && value !== ""
    )
  );
  const { data, isLoading } = useQuery({
    queryKey: ["TRANSACTION_HIFIAIR", cleanedFilter],
    queryFn: () => getTransactionHifiair(cleanedFilter),
    select: ({ data }) => data,
  });

  return { transaction: data, isLoading };
};
